import { render, staticRenderFns } from "./EthereumList.vue?vue&type=template&id=9bf505d8&scoped=true"
import script from "./EthereumList.vue?vue&type=script&lang=js"
export * from "./EthereumList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf505d8",
  null
  
)

export default component.exports